import React from 'react';

const AuthFooter: React.FC = () => {
    return (
        <>
            {/* standard index footer */}
            <div className="container-fluid text-center">
                <span className="small text-secondary">Casa A — Operação · Búzios / Trancoso</span>
            </div>
            {/* theming action*/}
            <div className="position-fixed bottom-0 end-0 m-3 z-index-5 fixedbuttons" id="fixedbuttons">
                <button className="btn btn-square btn-theme shadow rounded-circle" type="button" data-bs-toggle="offcanvas" data-bs-target="#theming" aria-controls="theming"><i className="bi bi-palette"></i></button>
                <br />
            </div>
        </>
    );
};

export default AuthFooter;
